import z from 'zod';
export const EMPLOYEE_GRAMMATICAL_GENDER = {
    FEMININE: 'feminine',
    MASCULINE: 'masculine',
};
export const EMPLOYEE_GENDER_ACCORD_BY_DOCX_VARIABLE = {
    SALARIE_1_ACCORD_ABSENT: {
        feminine: 'absente',
        masculine: 'absent',
    },
    SALARIE_1_ACCORD_AFFECTE: {
        feminine: 'Affectée',
        masculine: 'Affecté',
    },
    SALARIE_1_ACCORD_AFFECTE_AFFECTEE: {
        feminine: 'affectée',
        masculine: 'affecté',
    },
    SALARIE_1_ACCORD_AFFILIE_AFFILIEE: {
        feminine: 'affiliée',
        masculine: 'affilié',
    },
    SALARIE_1_ACCORD_AMENE_AMENEE: {
        feminine: 'amenée',
        masculine: 'amené',
    },
    SALARIE_1_ACCORD_ASSISTE_ASSISTEE: {
        feminine: 'assistée',
        masculine: 'assisté',
    },
    SALARIE_1_ACCORD_CANDIDAT_CANDIDATE: {
        feminine: 'Candidate',
        masculine: 'Candidat',
    },
    SALARIE_1_ACCORD_CE_DERNIER_CETTE_DERNIERE: {
        feminine: 'cette dernière',
        masculine: 'ce dernier',
    },
    SALARIE_1_ACCORD_CELUI_CI_CELLE_CI: {
        feminine: 'celle-ci',
        masculine: 'celui-ci',
    },
    SALARIE_1_ACCORD_CELUICI_CELLECI: {
        feminine: 'celle-ci',
        masculine: 'celui-ci',
    },
    SALARIE_1_ACCORD_CHER: {
        feminine: 'chère',
        masculine: 'cher',
    },
    SALARIE_1_ACCORD_CONDUIT_CONDUITE: {
        feminine: 'conduite',
        masculine: 'conduit',
    },
    SALARIE_1_ACCORD_CONTRAINT: {
        feminine: 'contrainte',
        masculine: 'contraint',
    },
    SALARIE_1_ACCORD_CONVOQUE: {
        feminine: 'convoquée',
        masculine: 'convoqué',
    },
    SALARIE_1_ACCORD_DECEDE_DECEDEE: {
        feminine: 'décédée',
        masculine: 'décédé',
    },
    SALARIE_1_ACCORD_EMBAUCHE: {
        feminine: 'embauchée',
        masculine: 'embauché',
    },
    SALARIE_1_ACCORD_EMPLOYE: {
        feminine: 'elle est employée',
        masculine: 'il est employé',
    },
    SALARIE_1_ACCORD_EMPLOYE_EMPLOYEE: {
        feminine: 'employée',
        masculine: 'employé',
    },
    SALARIE_1_ACCORD_ENGAGE_ENGAGEE: {
        feminine: 'engagée',
        masculine: 'engagé',
    },
    SALARIE_1_ACCORD_FORME_FORMEE: {
        feminine: 'formée',
        masculine: 'formé',
    },
    SALARIE_1_ACCORD_HABILITE_HABILITEE: {
        feminine: 'habilitée',
        masculine: 'habilité',
    },
    SALARIE_1_ACCORD_IL_ELLE: {
        feminine: 'elle',
        masculine: 'il',
    },
    SALARIE_1_ACCORD_INFORME: {
        feminine: 'informée',
        masculine: 'informé',
    },
    SALARIE_1_ACCORD_INFORME_INFORMEE: {
        feminine: 'informée',
        masculine: 'informé',
    },
    SALARIE_1_ACCORD_INSCRIT_INSCRITE: {
        feminine: 'inscrite',
        masculine: 'inscrit',
    },
    SALARIE_1_ACCORD_INTERESSE_INTERESSEE: {
        feminine: 'intéressée',
        masculine: 'intéressé',
    },
    SALARIE_1_ACCORD_INVITE: {
        feminine: 'invitée',
        masculine: 'invité',
    },
    SALARIE_1_ACCORD_INVITE_INVITEE: {
        feminine: 'invitée',
        masculine: 'invité',
    },
    SALARIE_1_ACCORD_LE_LA: {
        feminine: 'la',
        masculine: 'le',
    },
    SALARIE_1_ACCORD_LIBERE_LIBEREE: {
        feminine: 'libérée',
        masculine: 'libéré',
    },
    SALARIE_1_ACCORD_LIE: {
        feminine: 'liée',
        masculine: 'lié',
    },
    SALARIE_1_ACCORD_LIE_LIEE: {
        feminine: 'liée',
        masculine: 'lié',
    },
    SALARIE_1_ACCORD_MIS_MISE: {
        feminine: 'mise',
        masculine: 'mis',
    },
    SALARIE_1_ACCORD_NE: {
        feminine: 'née',
        masculine: 'né',
    },
    SALARIE_1_ACCORD_NE_NEE: {
        feminine: 'née',
        masculine: 'né',
    },
    SALARIE_1_ACCORD_PRESENT: {
        feminine: 'présente',
        masculine: 'présent',
    },
    SALARIE_1_ACCORD_PRESUME_PRESUMEE: {
        feminine: 'présumée',
        masculine: 'présumé',
    },
    SALARIE_1_ACCORD_PREVENU_PREVENUE: {
        feminine: 'prévenue',
        masculine: 'prévenu',
    },
    SALARIE_1_ACCORD_PRONOM_SUJET: {
        feminine: 'qu\'elle',
        masculine: 'qu\'il',
    },
    SALARIE_1_ACCORD_QUIL_QUELLE: {
        feminine: 'qu\'elle',
        masculine: 'qu\'il',
    },
    SALARIE_1_ACCORD_REINTEGRE: {
        feminine: 'réintégrée',
        masculine: 'réintégré',
    },
    SALARIE_1_ACCORD_REMPLI: {
        feminine: 'remplie',
        masculine: 'rempli',
    },
    SALARIE_1_ACCORD_REMPLI_REMPLIE: {
        feminine: 'remplie',
        masculine: 'rempli',
    },
    SALARIE_1_ACCORD_REPRESENTE_REPRESENTEE: {
        feminine: 'Représentée',
        masculine: 'Représenté',
    },
    SALARIE_1_ACCORD_REPUTE: {
        feminine: 'réputée',
        masculine: 'réputé',
    },
    SALARIE_1_ACCORD_SALARIE: {
        feminine: 'salariée',
        masculine: 'salarié',
    },
    SALARIE_1_ACCORD_SALARIE_SALARIEE: {
        feminine: 'salariée',
        masculine: 'salarié',
    },
    SALARIE_1_ACCORD_SALUTATION: {
        feminine: 'Chère Madame',
        masculine: 'Cher Monsieur',
    },
    SALARIE_1_ACCORD_SEUL_SEULE: {
        feminine: 'seule',
        masculine: 'seul',
    },
    SALARIE_1_ACCORD_SOUMIS: {
        feminine: 'soumise',
        masculine: 'soumis',
    },
    SALARIE_1_ACCORD_SOUSSIGNE: {
        feminine: 'soussignée',
        masculine: 'soussigné',
    },
    SALARIE_1_ACCORD_SOUSSIGNE_SOUSSIGNEE: {
        feminine: 'soussignée',
        masculine: 'soussigné',
    },
    SALARIE_1_ACCORD_TENU: {
        feminine: 'tenue',
        masculine: 'tenu',
    },
    SALARIE_1_ACCORD_TRANSFERE: {
        feminine: 'elle sera transférée',
        masculine: 'il sera transféré',
    },
};
const employeeGenderAccordDocxVariableValues = Object.keys(EMPLOYEE_GENDER_ACCORD_BY_DOCX_VARIABLE);
export const employeeGenderAccordDocxVariableValue = z.enum(employeeGenderAccordDocxVariableValues);
export const employeeGenderAccordDocxVariable = (value) => employeeGenderAccordDocxVariableValue.parse(value);
export const isEmployeeGenderAccordDocxVariable = (value) => employeeGenderAccordDocxVariableValue.safeParse(value).success;
const TITLE_OR_CIVILITY_TO_GENDER = {
    'M.': EMPLOYEE_GRAMMATICAL_GENDER.MASCULINE,
    Madame: EMPLOYEE_GRAMMATICAL_GENDER.FEMININE,
    Mme: EMPLOYEE_GRAMMATICAL_GENDER.FEMININE,
    Monsieur: EMPLOYEE_GRAMMATICAL_GENDER.MASCULINE,
};
export const resolveEmployeeGrammaticalGender = (titleOrCivilityLabel) => {
    if (titleOrCivilityLabel === null || titleOrCivilityLabel === undefined) {
        return null;
    }
    const trimmed = titleOrCivilityLabel.trim();
    if (trimmed.length === 0) {
        return null;
    }
    return TITLE_OR_CIVILITY_TO_GENDER[trimmed] ?? null;
};
export const resolveEmployeeGenderAccordValue = (docxKey, gender) => EMPLOYEE_GENDER_ACCORD_BY_DOCX_VARIABLE[docxKey][gender];
//# sourceMappingURL=employee-gender-accord-mapping.js.map